import { Image } from '../Image'
import LinkButton from './LinkButton'

export interface TestimonialData {
  text: string
  imgFilename: string
  imgAlt: string
  name: string
  job: string
  jobLink?: string
  jobLinkText?: string
  tryButton?: boolean
}

const Testimonial = ({
  text,
  imgFilename,
  imgAlt,
  name,
  job,
  jobLink,
  jobLinkText,
  tryButton = false,
}: TestimonialData) => {
  return (
    <div className="row">
      <div className="col-xs-12 testimonial">
        <div className="testimonial-content">
          <p className="testimonial-text">{text}</p>
          <Image
            className="testimonial-img"
            filename={imgFilename}
            alt={imgAlt}
          />
          <p className="testimonial-person-name">{name}</p>
          <p className="testimonial-person-job">
            {job}
            {jobLink && (
              <a href={jobLink} target="_blank" rel="noreferrer">
                {jobLinkText}
              </a>
            )}
          </p>
          {tryButton && (
            <div className="testimonial-try">
              <LinkButton
                url="/free-trial"
                label="Try free for 30 days"
                prefetch
                mobile
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Testimonial
